import { getAssignmentSeed } from '@thesisedu/feature-assignments-core'
import { useViewerContext } from '@thesisedu/feature-users-react'

export function useAssignmentSeed(questionId: string): string {
  const viewer = useViewerContext(false)
  return getAssignmentSeed(viewer?.id, questionId)
}
